import { IKeyValueHooks, IKeyValueSynchronous } from 'core-ts-types';

import { APCourse, IAPCourseMeta } from '../builders/ap_course_builder';
import { IAPSectionTypeDatasource } from './ap_section_type_datasource';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';

import * as _4 from 'lodash4';

export interface IAPCoursesDatasource
  extends IDatasource<APCourse, {}, IAPCourseMeta>,
    IKeyValueSynchronous<APCourse>,
    IKeyValueHooks<APCourse> {}

angular
  .module('capability-ng-academic-planner')
  .factory('ngAPCoursesDatasource', (ngAPSectionTypeDatasource: IAPSectionTypeDatasource) => {
    return new Datasource<APCourse, {}, IAPCourseMeta>({
      builderType: APCourse,
      updateMode: 'merge'
    }).includeMetasource<IAPCourseMeta>((datasource) => {
      return new Metasource<APCourse, IAPCourseMeta>(datasource);
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/datasources/ap_courses_datasource.ts